import okIcon from "../../../../common/images/okIcon.png";
import appstore from "../../../../common/images/appstore.png";
import googleplay from "../../../../common/images/googleplay.png";
import { isMobile } from "react-device-detect";

import backgroundImg from "../../../../common/images/backgroundImg.png";

import classes from "./SuccessPage.module.css";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import PageLoader from "../../../../common/ui/PageLoader";
import Button from "../../../../common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { RootStateStepper, stepperActions } from "../../store/stepper-slice";
import { useAppStore } from "../../../../providers/AppStore";
import useTheme from "../../../../common/hooks/useTheme";
import { useAuth } from "../../../../providers/AuthProvider";
import QuestionnaireScreenWrapperMobile from "./QuestionnaireScreenWrapperMobile";
import useScreenInfo from "../../../../providers/useScreenInfo";
import ScrollableWrapper from "../../../platform/components/common/ScrollableWrapper";
import PrimaryButton from "../../../../common/ui/PrimaryButton";

const SuccessPageQuestionnaire = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { ASGetUserSettings } = useAppStore();
  const { AuthUser } = useAuth();
  const theme = useTheme();
  const { orientation } = useScreenInfo();

  useEffect(() => {
    ASGetUserSettings(AuthUser);
  }, []);

  const hasLifeStyleQuestionnaireAccess =
    AuthUser.has_lifestyle_questionnaire_access;
  const lifestyleQuestionnaireCompleted =
    AuthUser.lifestyle_questionnaire_completed;

  if (hasLifeStyleQuestionnaireAccess && !lifestyleQuestionnaireCompleted) {
    dispatch(stepperActions.goToStep({ step: 1 }));
  }

  if (isMobile && orientation === "landscape") {
    return <QuestionnaireScreenWrapperMobile />;
  }

  return (
    <div className={classes.inner}>
      <ScrollableWrapper isScrollBarHidden={true}>
        <div
          style={{
            // width: "calc(100% + 24px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div className={classes.imgContainer}>
            <img className={classes.logo} src={okIcon} alt="success icon" />
          </div>

          <div
            className={classes.title}
            style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
          >
            {`You have successfully completed our ${
              location.pathname === "/success-lifestyle"
                ? "lifestyle"
                : "biometrics"
            } questionnaire!`}
          </div>
          <div
            className={classes.subTitle}
            style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
          >
            {hasLifeStyleQuestionnaireAccess && lifestyleQuestionnaireCompleted
              ? "Please proceed with the lifestyle questionnaire"
              : isMobile
              ? "Thank you for completing our questionnaire! You can now access your data on the Precision app or switch to the desktop platform for a full experience."
              : "Thank you for completing our questionnaire! You can now access your dashboard to explore personalized scores, programs, and insights tailored to you."}
          </div>
          {hasLifeStyleQuestionnaireAccess &&
          lifestyleQuestionnaireCompleted ? (
            <div className={classes.btnLifestyleContainer}>
              <PrimaryButton
                label={"Continue"}
                onClick={() => navigate("/lifestyle-questionnaire")}
              />
              <div
                className={classes.subtitle2}
                style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
              >
                Will only take 10 min
              </div>
            </div>
          ) : (
            <>
              {!isMobile && (
                <PrimaryButton
                  label={"Go to Dashboard"}
                  onClick={() => (window.location.href = "/platform/dashboard")}
                />
              )}
              <div className={classes.bottomContainer}>
                <div
                  className={classes.bottomText}
                  style={{ color: theme.colors_ds.NEUTRAL_TEXT_STRONG }}
                >
                  Download the App
                </div>
                <div className={classes.btnIcons}>
                  <a
                    href="https://play.google.com/store/apps/details?id=pnoe.rn.precision"
                    target="_blank"
                  >
                    <img
                      className={classes.img}
                      src={googleplay}
                      alt="icon google play"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/us/app/pno%C4%93-precision/id6450449936"
                    target="_blank"
                  >
                    <img
                      className={classes.img}
                      src={appstore}
                      alt="icon appstore"
                    />
                  </a>
                </div>
              </div>
            </>
          )}
        </div>
      </ScrollableWrapper>
    </div>
  );
};

export default SuccessPageQuestionnaire;
